export default {
  AUTOMATION_STARTED: 'AUTOMATION_STARTED',
  AUTOMATION_COMPLETED: 'AUTOMATION_COMPLETED',
};
